import { render, staticRenderFns } from "./OnRework.vue?vue&type=template&id=17a50a69&"
import script from "./OnRework.vue?vue&type=script&lang=js&"
export * from "./OnRework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports